import { useId } from "react";

type LogoProps = {
  compact?: boolean;
  markSize?: number;
};

export function LogoMark({ size = 36 }: { size?: number }) {
  const uid = useId().replace(/:/g, "");
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden>
      <defs>
        <linearGradient id={uid} x1="4" y1="36" x2="36" y2="4" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F97316" />
          <stop offset="1" stopColor="#FACC15" />
        </linearGradient>
      </defs>
      <circle cx="20" cy="20" r="20" fill={`url(#${uid})`} />
      <path
        d="M12.8 14.4c.5-3.2 3.4-5.6 7.2-5.6 4.1 0 6.9 2.4 6.9 5.5 0 2.8-1.9 4.4-5.6 5.6l-3.4 1.1c-2.8 1-4 2.2-4 4 0 2.4 2.3 4.1 6 4.1 3.6 0 6.2-1.9 6.9-4.8"
        stroke="#fff"
        strokeWidth="2.7"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="27.2" cy="24.6" r="1.85" fill="#fff" />
    </svg>
  );
}

export function Logo({ compact = false, markSize = 36 }: LogoProps) {
  return (
    <span className={`sw-logo${compact ? " sw-logo-compact" : ""}`}>
      <span className="sw-mark">
        <LogoMark size={markSize} />
      </span>
      <span className="sw-word">
        <strong>Softwave</strong>
        {!compact && <span>Markets</span>}
      </span>
    </span>
  );
}
